import * as React from 'react';
import { getIconCSSForAttachment } from '../utils/getIconCSSForAttachment';

const spriteStyles = require('owa-sprite/dist/styles/fileType_sprite.css');
const styles = require('./CloudIconWithOverlay.scss');
const iconStyles = require('./AttachmentIconView.scss');
const classNames = require('classnames');

export interface CloudIconWithOverlayProps {
    fileName: string;
    contentType: string;
    isBlocked: boolean;
    isFolder: boolean;
    embeddedItemClass: string;
    cloudyIconStyle?: any;
    fileIconStyle?: any;
}

export function CloudIconWithOverlay(props: CloudIconWithOverlayProps) {
    const {
        fileName,
        cloudyIconStyle,
        contentType,
        fileIconStyle,
        isBlocked,
        isFolder,
        embeddedItemClass,
    } = props;

    const cloudIconCSS: string = spriteStyles['fileType-icon-cloud_32x32'];
    const fileIconCSS: string = getIconCSSForAttachment(
        fileName,
        contentType,
        isBlocked,
        isFolder,
        embeddedItemClass
    ).small;

    return (
        <div
            className={classNames(
                iconStyles.icon,
                cloudIconCSS,
                cloudyIconStyle ? cloudyIconStyle : iconStyles.iconDefault
            )}>
            <div
                className={classNames(fileIconCSS, fileIconStyle ? fileIconStyle : styles.fileIcon)}
            />
        </div>
    );
}
